export const SEND_COOLDOWN_MS = 10_000;
